import { clearAppointmentPrimaryDeposit, removeAppointmentAddonDeposit } from "../../pages/calendar/Form/appointmentDeposit";
import { normalizeAppointmentResourceSelection } from "../../pages/calendar/appointmentResourceSelection";
import { containedAppointmentChildStart } from "./containedAppointmentTiming";
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import config from "../../config";
import { useTranslation } from "react-i18next";
import { servicePriceApi } from "store/slices/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { staffOptions } from "store/slices/staffSlice";
import { SaleServiceToCartApi } from "store/slices/saleSlice";
import { BookingLinkServiceOptionReset, BookingLinkServiceOptions, BookingLinkStaffOptionReset, BookingLinkStaffOptions } from "store/slices/bookinglinkSlice";
import { GetAvailableTime } from "./GetAvailableTime";
import { AddOnData, AddOnResourceOptionsApi, AddOnServicePriceApi, AddonStaffOptionsApi } from "store/slices/addonSlice";
import { AddonGetAvailableTime } from "./AddonGetAvailableTime";
import { MinutesToHours } from "helpers/Functions";
import { AddAnotherData, AddAnotherResourceOptionsApi, AddAnotherServicePriceApi, AddAnotherStaffOptionsApi } from "store/slices/addanotherSlice";
import { AddAnotherGetAvailableTime } from "./AddAnotherGetAvailableTime";
import { AddOnServiceButtonRender, AppointmentAutoFillFinalData, AppointmentAvailableTime, AppointmentResourceItemsApi, AppointmentResourceItemsClears, BookNextAvailableResourceApi, BookNextModalOpen, OpenDepositPayTab } from "store/slices/appointmentSlice";
import BeatLoader from "react-spinners/BeatLoader";
import moment from "moment";
import customToast from "component/Toastr";
import { Link } from "react-router-dom";
import { getServiceChangeResetFields, reconcileEditAppointmentServiceChange } from "./appointmentServiceChange";
import { getPrimaryServiceCost } from "./servicePrice";
import {
  resolveAppointmentAddonCost,
} from "./appointmentAddonPrice";
import { childResourceOptionState } from "./appointmentChildResourceOptions";
import { buildAppointmentChildOptionState, buildAppointmentServiceFields, normalizeAppointmentServiceTime, resolveAppointmentServiceStaffId } from "../../pages/calendar/appointmentServiceFields";
import { loadAppointmentAdditionalServiceSelection } from "./appointmentAdditionalServiceSelection";
import { buildServiceTierSelection } from "../../utils/serviceTierTiming";
import { keepsCustomCostOnStaffChange } from "./appointmentStaffChangeCost";

// interface Option {
//   label: string;
//   value: string;
// }

// interface CustomSelectProps extends FieldProps {
//   options: OptionsType;
//   isMulti?: boolean;
//   className?: string;
//   placeholder?: string;
// }

export const CustomSelect = ({ className, placeholder, field, form, options, isMulti = false, controlId, service_id = "", staff_id = "", defaultStaffId = null, page = "", isAddOn = "", isAddAnother = "", page_name = "", singlestaffaccess = "" }) => {
  const selectRef = useRef();
  const appliedDefaultStaff = useRef(null);
  const additionalSelectionRequest = useRef(0);
  const primarySelectionRequest = useRef(0);
  const latestValues = useRef(form.values);
  latestValues.current = form.values;
  const primarySelection = useRef({});
  primarySelection.current = { service_id: form.values?.service_id, staff_id: form.values?.staff_id };
  const salonId = useSelector(state => state.auth?.user?.salon_id);
  useEffect(() => () => { primarySelectionRequest.current += 1; }, [controlId, form.values?.id, salonId]);
  useEffect(() => () => { additionalSelectionRequest.current += 1; }, [controlId, form.values?.id]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ServiceApisLoading = useSelector((state) => state.service.isApiStatus);
  const AppointmentApiStatus = useSelector((state) => state.appointment.isApiStatus);
  useSelector(state => state.staff.isApiStatus);
  const appointmentStaffOptionServiceId = useSelector(state => state.staff.isStaffOptionServiceId);
  const appointmentStaffOptionsStatus = useSelector(state => state.staff.isApiStatus?.staffOptions);
  const appointmentStaffOptions = useSelector((state) => state.staff.isStaffOption);
  useSelector(state => state.appointment.isAppointmentAutofillData);
  const priceTierOptions = useSelector((state) => state.pricetier.isPriceTierOption);
  let noOptionsMessage = ({ inputValue } = {}) => {
    if (field.name === "staff_id" && controlId && controlId != "busytimeForm-staff_id") {
      const selectedService = form && form.values && form.values.service_id ? form.values.service_id : service_id;
      return selectedService ? t("No staff available for this service.") : t("Please Select a Service First.");
    }
    if (field.name === "service_id") {
      return t("No Services have been created yet. Please create one.");
    }
    if (field.name === "category_id") {
      return String(inputValue || "").trim()
        ? t("No categories match your search.")
        : t("No categories have been created yet. Please create one first.");
    }
    if (field.name === "supplier_id") {
      return t("No suppliers have been created yet. Please create one.");
    }
    if (field.name === "resource_item_id") {
      if (AppointmentApiStatus && AppointmentApiStatus.AppointmentResourceItemsApi === "loading") {
        return (<BeatLoader color="#8c1c4d" className="text-center" />);
      } else {
        if (form && form.values) {
          if (!form.values.service_id) {
            return t("Please Select a Service First.");
          } else if (!form.values.staff_id) {
            return t("Please Select a Staff First.");
          } else if (!form.values.dateof) {
            return t("Please Select a Date First.");
          } else if (!form.values.start_time) {
            return t("Please Select a Service Start Time First.");
          } else if (form.values.resource_required) {
            return t("No resource is available at this time. Choose another time.");
          } else {
            return t("No resource has been created yet or assigned to this service.");
          }
        } else {
          return t("No resource has been created yet or assigned to this service.");
        }
      }
    }
    if (field.name === "resource_id" && controlId && controlId === "serviceForm-resource_id") {
      if (ServiceApisLoading && ServiceApisLoading.ServiceResourceDropdownApi === "loading") {
        return (<BeatLoader color="#8c1c4d" className="text-center" />)
      } else {
        return (
          <span>
            {t('No resource has been created yet.')}
            <br />
            <Link to={"/resource"}>{t('Please create one.')}</Link>
          </span>
        );
      }
    }
    return t("No options");
  };

  const onChange = (option) => {
    if (field.name === "category_id" && controlId === "bookingButtonForm-category_id") {
      dispatch(BookingLinkStaffOptionReset());
      dispatch(BookingLinkServiceOptionReset());
      form.setFieldValue('service_id', "");
      form.setFieldValue('staff_id', "");
      if (option && option.value) {
        dispatch(BookingLinkServiceOptions({ option: { valueField: "id", labelField: "name" }, category_id: option && option.value, pagetype: 'Booking' }));
      } else {
        dispatch(BookingLinkServiceOptionReset());
      }
    }
    if (field.name === "service_id" && controlId === "bookingButtonForm-service_id") {
      if (option && option.value) {
        dispatch(BookingLinkStaffOptions({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: option && option.value, singlestaffaccess: singlestaffaccess, page_name: page_name, pagetype: 'Booking' }));
      } else {
        dispatch(BookingLinkStaffOptionReset());
        form.setFieldValue('staff_id', "");
      }
    }
    if (field.name === "service_id" && controlId === "appointmentautofillForm-service_id") {
      if (option && option.value) {
        if (form.values.selectedOptionType === "staff") {
          form.setFieldValue("resource_item_id", "", false);
        }
        form.setFieldValue("resource_allocations", [], false);
        form.setFieldValue("service_resource_required", false, false);
        dispatch(AppointmentAvailableTime(""));
        dispatch(BookNextModalOpen(false));
        // The previous service's resource items are still in the store and
        // would render as this service's Resource options until a new read
        // settles (or forever when none is issued). Drop them now so the
        // dropdown cannot offer resources for a service that has none.
        dispatch(AppointmentResourceItemsClears());
        dispatch(AddOnServiceButtonRender(false));
        dispatch(servicePriceApi({ service_id: option && option.value, staff_id: form.values.staff_id })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            // form.setFieldValue("warningMessage","");
            let service = action.payload;
            form.setFieldValue("add_on_within_original_time", [true, 1, "1"].includes(service?.add_on_within_original_time), false);
            const serviceResourceRequired = Boolean(service?.resource_id || service?.resource_requirements?.length);
            form.setFieldValue("service_resource_required", serviceResourceRequired, false);
            // if (!form.values.lastObj) {
            //   form.setFieldValue("lastObj", { ...form.values });
            // } else {
            //   const lastObj = form.values.lastObj;
            //   form.setFieldValue("available_time_obj", lastObj.available_time_obj);
            //   form.setFieldValue("resource_item_id", lastObj.resource_item_id);
            //   form.setFieldValue("dateof", lastObj.dateof);
            //   form.setFieldValue("start_datetime", lastObj.start_datetime);
            //   form.setFieldValue("start_time", lastObj.start_time);
            //   form.setFieldValue("display_text", lastObj.display_text);
            //   form.setFieldValue("BookNextModalOpen", lastObj.BookNextModalOpen);
            //   form.values.available_time_obj = lastObj.available_time_obj
            //   form.values.resource_item_id = lastObj.resource_item_id
            //   form.values.dateof = lastObj.dateof
            //   form.values.start_datetime = lastObj.start_datetime
            //   form.values.start_time = lastObj.start_time
            //   form.values.display_text = lastObj.display_text
            //   form.values.BookNextModalOpen = lastObj.BookNextModalOpen
            // }

            const tierSelection = buildServiceTierSelection(
              service,
              service?.serviceprice?.[0] || service?.staffservicesprice,
            );
            const duration = tierSelection.duration;
            const padding_time = tierSelection.padding_time;
            const durationWithPadding = tierSelection.durationWithPadding;

            if (service && service.add_on_services_count && service.add_on_services_count > 0) {
              dispatch(AddOnServiceButtonRender(true));
            } else if (service && service.add_on_services_count && service.add_on_services_count <= 0) {
              dispatch(AddOnServiceButtonRender(false));
            }

            form.setFieldValue("duration", duration);
            form.setFieldValue("padding_time", padding_time);
            form.setFieldValue("durationWithPadding", durationWithPadding);

            if (service && service.serviceprice && option) {
              let serviceprice = service.serviceprice;
              let generalPrice = serviceprice;
              let depositsPriceState = service && service.deposit_booked_price ? parseFloat(service.deposit_booked_price) : 0;
              let gprice = generalPrice && generalPrice.length === 1 ? generalPrice[0].price : "0.00";
              // let add_on_price = generalPrice && generalPrice.length === 1 ? generalPrice[0].add_on_price : "0.00";
              // let totalprice = parseFloat(gprice) + parseFloat(add_on_price); //client need only gprice 16-12-2022
              let totalprice = parseFloat(gprice);
              form.setFieldValue('cost', String(totalprice));
              const updatedServiceDeposit = [
                { service_id: option && option.value, deposit_price: service.deposit_booked_price, service_type: "primary", total_cost: service && service.serviceprice && service.serviceprice.length > 0 ? service.serviceprice[0].price : "0" },
              ];
              form.setFieldValue("service_deposit", updatedServiceDeposit);
              if (service && depositsPriceState && depositsPriceState > 0 && service.deposit_booked_online == 1) {
                form.setFieldValue("totaldeposit", depositsPriceState);
                dispatch(OpenDepositPayTab(true));
              } else {
                form.setFieldValue("totaldeposit", 0);
                dispatch(OpenDepositPayTab(false));
              }

            }
            const dateof = form.values.start_datetime
              ? moment(form.values.start_datetime, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss"], true).format("YYYY-MM-DD HH:mm:ss")
              : form.values.dateof && moment(form.values.dateof, ["dddd, D MMMM YYYY", "dddd, DD MMMM YYYY"], true).isValid()
                ? moment(form.values.dateof, ["dddd, D MMMM YYYY", "dddd, DD MMMM YYYY"], true).format("YYYY-MM-DD") + " " + (form.values.start_time || "00:00") + ":00"
                : "";
            const obj = {
              appointment_id: "",
              busytime_id: "",
              dateof: dateof,
              start_datetime: form.values.start_datetime,
              duration: duration,
              padding_time: padding_time,
              durationWithPadding: durationWithPadding,
              listview: "Appointment",
              salon_id: form.values.salon_id,
              service_id: option && option.value,
              staff_id: form.values.staff_id,
              resource_item_id: form.values.selectedOptionType === "staff" ? "" : form.values.resource_item_id,
              uid: 1,
              formtype: "appointmentautofillForm",
              selectedOptionType: form.values.selectedOptionType,
              formName: "appointmentForm/autofill/service"
            }
            form.setFieldValue("available_time_obj", obj);
            // The conflict dialog owns the cross-staff/date alternative search.
            // This read only validates the selected staff's current day.
            GetAvailableTime({ ...obj, isDurationCheck: true }, dispatch);

            if (form.values.selectedOptionType === "staff") {
              dispatch(AppointmentResourceItemsApi({
                option: { valueField: "id", labelField: "resource_item" },
                service_id: option && option.value,
                availebleTimeObj: obj
              }));
            }

            if (form.values.selectedOptionType === "resourceItem") {
              dispatch(staffOptions({
                option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" },
                service_id: option && option.value,
                pagetype: "Booking",
                availebleTimeObj: obj
              })).then(action => {
                if (action.meta.requestStatus === "rejected") {
                  customToast.error("Staff is not avaialble");
                }
              });
            }
            // GetAvailableTime(obj, dispatch);
            // dispatch(staffOptions({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking", singlestaffaccess: singlestaffaccess, page_name: page_name }));
            //dispatch(AddOnServicesApi({ service_id: service.id }));
            dispatch(AddOnData(""));
            dispatch(AddAnotherData(""));
          }
        });
      } else {
        if (controlId === "appointmentautofillForm-service_id") {
          form.setFieldValue("duration", "");
          form.setFieldValue("cost", "");
          form.setFieldTouched("cost", false);
          form.setFieldValue("service_deposit", []);
          form.setFieldValue("totaldeposit", "");
          // form.setFieldValue("warningMessage","");
          dispatch(AppointmentResourceItemsClears());
        }
        dispatch(AddOnServiceButtonRender(false));
        // dispatch(staffOptions({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, pagetype: "Booking", singlestaffaccess: singlestaffaccess, page_name: page_name }));
        dispatch(AddOnData(""));
        dispatch(AddAnotherData(""));
      }
    }
    if (field.name === "staff_id" && controlId === "appointmentautofillForm-staff_id") {
      if (option && option.value) {
        dispatch(servicePriceApi({ staff_id: option && option.value, service_id: service_id && service_id })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            const tierSelection = buildServiceTierSelection(
              serviceData,
              serviceData?.serviceprice?.[0] || serviceData?.staffservicesprice,
            );
            const duration = tierSelection.duration;
            const padding_time = tierSelection.padding_time;
            const durationWithPadding = tierSelection.durationWithPadding;

            form.setFieldValue("duration", duration);
            form.setFieldValue("padding_time", padding_time);
            form.setFieldValue("durationWithPadding", durationWithPadding);
            // const duration = service && service.duration ? MinutesToHours(service.duration) : "";
            if (controlId === "appointmentautofillForm-staff_id") {

              const obj = {
                appointment_id: "",
                busytime_id: "",
                dateof: form.values.dateof,
                start_datetime: form.values.start_datetime,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                listview: "Appointment",
                salon_id: form.values.salon_id,
                service_id: form.values.service_id,
                staff_id: option && option.value,
                resource_item_id: form.values.resource_item_id,
                uid: 1,
                formtype: "appointmentautofillForm",
                selectedOptionType: form.values.selectedOptionType,
                formName: "appointmentForm/autofill/staff"
              }
              form.setFieldValue("available_time_obj", obj);
              dispatch(AppointmentResourceItemsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: obj.service_id, availebleTimeObj: obj })).then((action) => {
                // Services without resources still resolve their staff time. Resource
                // alternatives belong to the modal and require an explicit choice.
                if (action.meta.requestStatus !== "fulfilled" || !Array.isArray(action.payload) || action.payload.length || serviceData?.resource_id || serviceData?.resource_requirements?.length) return;
                dispatch(BookNextAvailableResourceApi(obj)).then((nextAction) => {
                  const next = nextAction.payload;
                  if (nextAction.meta.requestStatus !== "fulfilled" || next?.service_assign_resource || !next?.start_datetime || !next?.time?.length) return;
                  const date = moment(next.start_datetime, "YYYY-MM-DD HH:mm:ss");
                  form.setFieldValue("dateof", date.format("dddd, DD MMMM YYYY"), false);
                  form.setFieldValue("start_datetime", next.start_datetime, false);
                  form.setFieldValue("start_time", date.format("HH:mm"), false);
                  form.setFieldValue("available_time_obj", { ...obj, start_datetime: next.start_datetime }, false);
                  dispatch(AppointmentAvailableTime({ time: next.time }));
                });
              });
              GetAvailableTime({ ...form.values, duration: durationWithPadding, staff_id: option && option.value, listview: "Appointment", formtype: "appointmentautofillForm", isDurationCheck: true }, dispatch);
            }
            // let service = action.payload;
            // let serviceprice = service && service.serviceprice && service.serviceprice[0] && service.serviceprice[0].price ? service.serviceprice[0].price : "";
            // form.setFieldValue("cost", serviceprice);
          }
        });
      } else {
        GetAvailableTime({
          ...form.values,
          staff_id: option && option.value,
          duration: "",
          padding_time: "",
          durationWithPadding: "",
          listview: "Appointment",
          isDurationCheck: true
        }, dispatch);
      }
    }
    if (field.name === "resource_item_id" && controlId === "appointmentautofillForm-resource_item_id") {
      if (option && option.value) {
        if (controlId === "appointmentautofillForm-resource_item_id") {
          dispatch(AppointmentAvailableTime(""));
          dispatch(AppointmentResourceItemsApi({
            option: { valueField: "id", labelField: "resource_item" },
            service_id: form.values.service_id,
            availebleTimeObj: { ...form.values, resource_item_id: option.value, listview: "Appointment", formtype: "appointmentautofillForm" },
          }));
          GetAvailableTime({
            ...form.values,
            resource_item_id: option && option.value,
            listview: "Appointment",
            formtype: "appointmentautofillForm",
            isDurationCheck: true,
            formName: "appointmentautofillForm/resource_item"
          }, dispatch);
        }
      } else {
        GetAvailableTime({
          ...form.values,
          resource_item_id: option && option.value,
          // duration: "",
          // padding_time: "",
          // durationWithPadding: "",
          listview: "Appointment",
          isDurationCheck: true,
          formName: "appointmentautofillForm"
        }, dispatch);
      }
    }
    if (field.name === "service_id" && controlId === "appointmentForm-service_id") {
      const request = ++primarySelectionRequest.current;
      primarySelection.current.service_id = option?.value || "";
      form.setFieldValue("resource_allocations", [], false);
      if (option && option.value) {
        dispatch(AddOnServiceButtonRender(false));
        // Same per-service reset as the Book Next modal: a service change must
        // not leave the previous service's resources in the Resource dropdown.
        dispatch(AppointmentResourceItemsClears());
        const resetFields = getServiceChangeResetFields({
          formType: form.values && form.values.form_types,
          hasSelectedService: true,
          // The normal time picker stores dateof/start_time without caching
          // start_datetime. Preserve the actual choices in both entry paths.
          preserveCalendarSlot: Boolean(form.values?.staff_id || form.values?.start_time),
        });
        resetFields.forEach((fieldName) => form.setFieldValue(fieldName, ""));
        const retainedStaffId = !resetFields.includes("staff_id") && form.values?.staff_id;
        dispatch(servicePriceApi({
          service_id: option.value,
          ...(retainedStaffId ? { staff_id: retainedStaffId } : {}),
        })).then((action) => {
          if (request !== primarySelectionRequest.current || String(primarySelection.current.service_id) !== String(option.value)) return;
          const serviceData = action && action.payload;
          const currentValues = latestValues.current;
          if (action.meta.requestStatus === "fulfilled") {
            form.setFieldValue("service_resource_required", Boolean(serviceData?.resource_id || serviceData?.resource_requirements?.length), false);
            const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "";
            const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")
            if (controlId === "appointmentForm-service_id") {
              form.setFieldValue("add_on_within_original_time", [true, 1, "1"].includes(serviceData?.add_on_within_original_time), false);
              // The therapist picker owns its own tier lookup. A slower lookup
              // requested for the previous therapist must not replace that tier.
              const sameTherapist = String(currentValues?.staff_id || "") === String(retainedStaffId || "");
              if (sameTherapist) {
                form.setFieldValue("duration", duration);
                form.setFieldValue("padding_time", padding_time);
                form.setFieldValue("durationWithPadding", durationWithPadding);
                form.setFieldValue("cost", getPrimaryServiceCost(serviceData, priceTierOptions));
                form.setFieldTouched("cost", false);
              }

              if (currentValues && currentValues.form_types && currentValues.form_types === "add_appointment") {
                form.setFieldValue("addonservices", []);
                dispatch(AddOnData(""));
              }

              if (serviceData && serviceData.add_on_services_count && serviceData.add_on_services_count > 0) {
                dispatch(AddOnServiceButtonRender(true));
              } else if (serviceData && serviceData.add_on_services_count && serviceData.add_on_services_count <= 0) {
                dispatch(AddOnServiceButtonRender(false));
              }
              const assignmentUpdates = reconcileEditAppointmentServiceChange(serviceData, currentValues);
              assignmentUpdates.forEach(({ field, value }) => form.setFieldValue(field, value));
              if (assignmentUpdates.some(({ field }) => field === "staff_id")) {
                customToast.error(t("The selected therapist does not offer this service. Choose another therapist; your selected time has been kept for availability checking."));
              }
              const isEditing = currentValues?.form_types === "edit_appointment";
              const configuredDeposit = serviceData?.deposit_booked_online == 1
                ? Math.max(0, Number(serviceData.deposit_booked_price) || 0) : 0;
              const updatedServiceDeposit = [
                { service_id: option.value, deposit_price: configuredDeposit.toFixed(2), service_type: "primary", total_cost: getPrimaryServiceCost(serviceData, priceTierOptions) },
                ...(Array.isArray(currentValues.service_deposit)
                  ? currentValues.service_deposit.filter(line => isEditing
                    ? line.service_type !== "primary" : line.service_type === "add_another"
                      && currentValues.addanotherservices?.some(child => String(child.service_id) === String(line.service_id))) : []),
              ];
              const requiredMinor = updatedServiceDeposit.reduce((sum, line) =>
                sum + Math.round(Math.max(0, Number(line.deposit_price) || 0) * 100), 0);
              const paidMinor = isEditing
                ? Math.round(Math.max(0, Number(currentValues.previous_deposit_paid) || 0) * 100) : 0;
              const remainingDeposit = isEditing
                ? (Math.max(0, requiredMinor - paidMinor) / 100).toFixed(2)
                : (Number(clearAppointmentPrimaryDeposit(currentValues).totaldeposit)
                  + configuredDeposit).toFixed(2);
              form.setFieldValue("service_deposit", updatedServiceDeposit);
              form.setFieldValue("totaldeposit", remainingDeposit);
              dispatch(OpenDepositPayTab(Number(remainingDeposit) > 0));
            }
            let formName = "";
            if (currentValues && currentValues.form_types) {
              formName = currentValues.form_types === "add_appointment" ? "appointmentForm/add/service_id" : (currentValues.form_types === "edit_appointment" ? "appointmentForm/edit/service_id" : "")
            }
            // dispatch(AppointmentResourceItemsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: option && option.value }));
            dispatch(staffOptions({
              option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" },
              service_id: serviceData.id,
              pagetype: "Booking",
              singlestaffaccess: singlestaffaccess,
              page_name: page_name,
              formName
            }));

            //dispatch(AddOnServicesApi({ service_id: service.id }));
            // GetAvailableTime({
            //   ...form.values,
            //   service_id: option && option.value,
            //   duration: duration,
            //   padding_time: padding_time,
            //   durationWithPadding: durationWithPadding,
            //   isDurationCheck: true,
            //   listview: "Appointment",
            //   prev_start_datetime: form.values?.prev_start_datetime
            // }, dispatch);
            // dispatch(AddOnData(""));
            // dispatch(AddAnotherData(""));
            dispatch(AppointmentAutoFillFinalData(""));
          }
        });
      } else {
        if (controlId === "appointmentForm-service_id") {
          form.setFieldValue("duration", "");
          form.setFieldValue("padding_time", "");
          form.setFieldValue("durationWithPadding", "");
          getServiceChangeResetFields({
            formType: form.values && form.values.form_types,
            hasSelectedService: false,
          }).forEach((fieldName) => form.setFieldValue(fieldName, "", fieldName !== "resource_item_id"));
          form.setFieldValue("cost", "");
          form.setFieldTouched("cost", false);
          if (form.values && form.values.form_types === "add_appointment") {
            form.setFieldValue("addonservices", []);
            dispatch(AddOnData(""));
            const deposit = clearAppointmentPrimaryDeposit(form.values);
            form.setFieldValue("service_deposit", deposit.service_deposit);
            form.setFieldValue("totaldeposit", deposit.totaldeposit);
          } else {
            form.setFieldValue("service_deposit", "");
            form.setFieldValue("totaldeposit", "0.00");
          }

        }
        dispatch(OpenDepositPayTab(form.values.form_types === "add_appointment"
          && Number(clearAppointmentPrimaryDeposit(form.values).totaldeposit) > 0));
        dispatch(AppointmentResourceItemsClears());
        dispatch(AddOnServiceButtonRender(false));

        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/service_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/service_id" : "")
        }
        dispatch(staffOptions({
          option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" },
          pagetype: "Booking",
          singlestaffaccess: singlestaffaccess,
          page_name: page_name,
          formName
        }));
        // GetAvailableTime({
        //   ...form.values,
        //   service_id: option && option.value,
        //   duration: "",
        //   padding_time: "",
        //   durationWithPadding: "",
        //   isDurationCheck: true,
        //   listview: "Appointment",
        //   prev_start_datetime: form.values?.prev_start_datetime
        // }, dispatch);
        // dispatch(AddOnData(""));
        // dispatch(AddAnotherData(""));
        dispatch(AppointmentAutoFillFinalData(""));
      }
    }
    if ((field.name === "staff_id" && controlId === "appointmentForm-staff_id") || page === "newsale") {
      const request = ++primarySelectionRequest.current;
      primarySelection.current.staff_id = option?.value || "";
      const keepCustomCost = controlId === "appointmentForm-staff_id" && keepsCustomCostOnStaffChange(form);
      if (option && option.value) {
        dispatch(servicePriceApi({ staff_id: option && option.value, service_id: service_id && service_id })).then((action) => {
          if (controlId === "appointmentForm-staff_id" && (
            request !== primarySelectionRequest.current ||
            String(primarySelection.current.service_id) !== String(service_id) ||
            String(primarySelection.current.staff_id) !== String(option.value)
          )) return;
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            // const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            // const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "00:00";
            // const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")
            const tierSelection = buildServiceTierSelection(
              serviceData,
              serviceData?.serviceprice?.[0] || serviceData?.staffservicesprice,
            );
            const duration = tierSelection.duration;
            const padding_time = tierSelection.padding_time;
            const durationWithPadding = tierSelection.durationWithPadding;
            const ServiceCost = tierSelection.price;
            // const duration = service && service.duration ? MinutesToHours(service.duration) : "";
            let formName = "";
            if (form.values && form.values.form_types) {
              formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/staff_id" : "")
            }
            if (controlId === "appointmentForm-staff_id") {
              GetAvailableTime({
                ...form.values,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                staff_id: option && option.value,
                listview: "Appointment",
                isDurationCheck: true,
                prev_start_datetime: form.values?.prev_start_datetime,
                formName
              }, dispatch);
              form.setFieldValue("duration", duration);
              form.setFieldValue("padding_time", padding_time);
              form.setFieldValue("durationWithPadding", durationWithPadding);
              form.setFieldValue("resource_item_id", "");
              if (!keepCustomCost) form.setFieldValue("cost", parseFloat(ServiceCost));
              if (form.values && form.values.form_types === "add_appointment") {
                form.setFieldValue("addonservices", []);
                dispatch(AddOnData(""));
              }
              if (form.values.form_types === "add_appointment") {
                const deposit = removeAppointmentAddonDeposit(form.values);
                form.setFieldValue("service_deposit", deposit.service_deposit);
                form.setFieldValue("totaldeposit", deposit.totaldeposit);
                dispatch(OpenDepositPayTab(Number(deposit.totaldeposit) > 0));
              }
              if (!keepCustomCost) form.setFieldValue("cost", tierSelection.price);

              dispatch(AppointmentAutoFillFinalData(""));
            }
            if (serviceData && serviceData.serviceprice && page === "newsale" && option) {
              let serviceprice = serviceData.serviceprice;
              let totalprice = tierSelection.price;
              let name = field.name;
              let field_gprice = name.replace("staff_id", "gprice");
              let field_staff_name = name.replace("staff_id", "staff_name");
              form.setFieldValue(String(field_gprice), String(totalprice));
              form.setFieldValue(String(field_staff_name), String(option.label));
              dispatch(SaleServiceToCartApi({
                service_id: service_id,
                gprice: String(totalprice),
                duration: tierSelection.durationMinutes,
                duration_with_padding: tierSelection.durationWithPaddingMinutes,
                staff: {
                  id: option.value,
                  name: option.label,
                  serviceprice: serviceprice && serviceprice.length === 1 && serviceprice[0],
                  totalprice: String(totalprice),
                  duration: tierSelection.durationMinutes,
                  duration_with_padding: tierSelection.durationWithPaddingMinutes,
                },
              })).then((action1) => {
                if (action1.meta.requestStatus === "fulfilled") {
                }
              });
            }
            // let service = action.payload;
            // let serviceprice = service && service.serviceprice && service.serviceprice[0] && service.serviceprice[0].price ? service.serviceprice[0].price : "";
            // form.setFieldValue("cost", serviceprice);
          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/staff_id" : "")
        }
        GetAvailableTime({
          ...form.values,
          staff_id: option && option.value,
          duration: "",
          padding_time: "",
          durationWithPadding: "",
          listview: "Appointment",
          isDurationCheck: true,
          prev_start_datetime: form.values?.prev_start_datetime,
          formName
        }, dispatch);
        dispatch(AppointmentResourceItemsClears());
        // form.setFieldValue("duration", "");
        // form.setFieldValue("padding_time", "");
        // form.setFieldValue("durationWithPadding", "");
        form.setFieldValue("resource_item_id", "");
        form.setFieldValue("cost", "");
        form.setFieldTouched("cost", false);
        if (form.values && form.values.form_types === "add_appointment") {
          form.setFieldValue("addonservices", []);
          dispatch(AddOnData(""));
        }
        if (form.values.form_types === "edit_appointment") {
          const updatedServiceDeposit = form.values.service_deposit && form.values.service_deposit.length > 0 && form.values.service_deposit.filter((item) => item.service_type != "add_another");
          form.setFieldValue("service_deposit", updatedServiceDeposit);
          let totalDeposit = form.values.totaldeposit;
          updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
            totalDeposit = parseFloat(item.deposit_price) - parseFloat(form.values.previous_deposit_paid) > 0 ? parseFloat(item.deposit_price) - parseFloat(form.values.previous_deposit_paid) : 0;
          });
          const formattedTotalDeposit = totalDeposit ? typeof totalDeposit === 'number' ? parseFloat(totalDeposit).toFixed(2) : parseFloat(totalDeposit) : 0;
          form.setFieldValue("totaldeposit", formattedTotalDeposit ? formattedTotalDeposit : 0);
        } else if (form.values.form_types === "add_appointment") {
          const deposit = removeAppointmentAddonDeposit(form.values);
          form.setFieldValue("service_deposit", deposit.service_deposit);
          form.setFieldValue("totaldeposit", deposit.totaldeposit);
          dispatch(OpenDepositPayTab(Number(deposit.totaldeposit) > 0));
        }

        dispatch(AppointmentAutoFillFinalData(""));
      }
    }
    if (field.name === "resource_item_id" && controlId === "appointmentForm-resource_item_id") {
      if (option && option.value) {
        dispatch(servicePriceApi({ staff_id: staff_id, service_id: service_id && service_id })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            void (action.payload);
            // const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            // const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "";
            // const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")
            const duration = form.values.duration && /^\d{1,2}:\d{2}$/.test(form.values.duration) ? form.values.duration : "";
            const padding_time = form.values.padding_time && /^\d{1,2}:\d{2}$/.test(form.values.padding_time) > 0 ? form.values.padding_time : "";
            let durationWithPadding = duration;
            if (padding_time) {
              const duration1 = moment.duration(duration);
              const duration2 = moment.duration(padding_time);

              const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;

              const sumDuration = moment({ hours, minutes });
              const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

              // const durationMoment = moment.duration(SumOfDuration);
              durationWithPadding = SumOfDuration
            }
            // const duration = service && service.duration ? MinutesToHours(service.duration) : "";
            if (controlId === "appointmentForm-resource_item_id") {
              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/resource_item_id" : "")
              }
              GetAvailableTime({
                ...form.values,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                resource_item_id: option && option.value,
                listview: "Appointment",
                isDurationCheck: true,
                selectedOptionType: "resource_item_id",
                prev_start_datetime: form.values?.prev_start_datetime,
                formName
              }, dispatch);
              form.setFieldValue("duration", duration);
              if (!form.values.padding_time || !(/^\d{1,2}:\d{2}$/.test(form.values.padding_time))) {
                // If padding_time is null, undefined, empty string, or not in the correct format
                // Reset it to some default value. Assuming `padding_time` is the variable holding the default
                form.setFieldValue("padding_time", padding_time); // reset to default
              }
              form.setFieldValue("durationWithPadding", durationWithPadding);
              // form.setFieldValue("start_time", "");
              if (form.values && form.values.form_types === "add_appointment") {
                form.setFieldValue("addonservices", []);
                dispatch(AddOnData(""));
                const deposit = removeAppointmentAddonDeposit(form.values);
                form.setFieldValue("service_deposit", deposit.service_deposit);
                form.setFieldValue("totaldeposit", deposit.totaldeposit);
                dispatch(OpenDepositPayTab(Number(deposit.totaldeposit) > 0));
              }

              if (controlId === "appointmentForm-staff_id" && form.values && form.values.form_types === "add_appointment") {
                let totalDeposits = form.values.totaldeposit;
                const updatedServiceDeposit = form.values.service_deposit && form.values.service_deposit.length > 0 && form.values.service_deposit.filter((item) => item.service_type != "add_another");
                updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
                  totalDeposits = parseFloat(item.deposit_price);
                });
                form.setFieldValue("totaldeposit", parseFloat(totalDeposits).toFixed(2));
              }
              dispatch(AppointmentAutoFillFinalData(""));
            }

          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/resource_item_id" : "")
        }
        GetAvailableTime({
          ...form.values,
          resource_item_id: option && option.value,
          // duration: "",
          // padding_time: "",
          // durationWithPadding: "",
          isDurationCheck: true,
          listview: "Appointment",
          prev_start_datetime: form.values?.prev_start_datetime,
          formName
        }, dispatch);
        // form.setFieldValue("resource_item_id", "");
        // form.setFieldValue("duration", "");
        // form.setFieldValue("padding_time", "");
        // form.setFieldValue("durationWithPadding", "");
        // form.setFieldValue("cost", "");
        // form.setFieldTouched("cost", false);
        form.setFieldValue("addonservices", []);

        if (form.values.form_types === "edit_appointment") {
          const updatedServiceDeposit = form.values.service_deposit && form.values.service_deposit.length > 0 && form.values.service_deposit.filter((item) => item.service_type != "add_another");
          form.setFieldValue("service_deposit", updatedServiceDeposit);
          let totalDeposit = form.values.totaldeposit;
          updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
            totalDeposit = parseFloat(item.deposit_price) - parseFloat(form.values.previous_deposit_paid) > 0 ? parseFloat(item.deposit_price) - parseFloat(form.values.previous_deposit_paid) : "0.00";
          });
          const formattedTotalDeposit = totalDeposit ? typeof totalDeposit === 'number' ? parseFloat(totalDeposit).toFixed(2) : parseFloat(totalDeposit) : 0;
          form.setFieldValue("totaldeposit", formattedTotalDeposit ? formattedTotalDeposit : 0);
        } else if (form.values.form_types === "add_appointment") {
          const deposit = removeAppointmentAddonDeposit(form.values);
          form.setFieldValue("service_deposit", deposit.service_deposit);
          form.setFieldValue("totaldeposit", deposit.totaldeposit);
          dispatch(OpenDepositPayTab(Number(deposit.totaldeposit) > 0));
        }
        dispatch(AddOnData(""));
        dispatch(AppointmentAutoFillFinalData(""));
      }
    }
    if (field.name === "staff_id" && controlId === "busytimeForm-staff_id") {
      let formName = "";
      if (form.values && form.values.form_types) {
        formName = form.values.form_types === "add_busytime" ? "busytimeForm/add/staff_id" : (form.values.form_types === "edit_busytime" ? "busytimeForm/edit/staff_id" : "")
      }
      GetAvailableTime({
        ...form.values,
        staff_id: option && option.value,
        listview: "BusyTime",
        availableBusyTime: "start",
        isDurationCheck: true,
        formtype: form.values?.formtype || form.values?.form_types || "",
        formName
      }, dispatch);
    }
    if (field.name === "voucher_id" && controlId === "BuyVoucherForm-voucher_id") {
      if (option) {
        const vlabel = option.label ? option.label.split("-") : [];
        const vlabelAmount = vlabel.length == 2 ? vlabel[1].trim().replace("$", "") : 0;
        form.setFieldValue("amount", String(option?.amount || vlabelAmount), false);
      } else {
        form.setFieldValue("amount", "", false);
      }

      // form.setFieldValue("amount", "");
    }

    let getFieldName = field.name && field.name.split(".");
    let getFieldNameIndex = getFieldName && getFieldName.length == 3 ? getFieldName[1] : "";
    let getControlId = controlId && controlId.split("-");
    if (getFieldName.length == 3 && getFieldName.includes("addonservices") && getFieldName.includes("service_id") && getControlId.includes("appointmentForm") && getControlId.includes("addonservices") && getControlId.includes("service_id")) {
      if (option && option.value) {
        dispatch(AddOnServicePriceApi({ parent_service_id: form.values.service_id, parent_staff_id: form.values.staff_id, service_id: option && option.value, staff_id: form.values.staff_id, index_id: getFieldNameIndex })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            const serviceFields = buildAppointmentServiceFields(
              { ...serviceData, service_id: serviceData.id },
              form.values.staff_id,
            );
            const duration = normalizeAppointmentServiceTime(serviceFields.duration);
            const padding_time = serviceFields.padding_time;
            const durationWithPadding = serviceFields.durationWithPadding;
            const addonCost = resolveAppointmentAddonCost(serviceData);

            if (controlId === `appointmentForm-addonservices-${getFieldNameIndex}-service_id`) {
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.service_name`, serviceData.name);
              form.setFieldValue(
                `${getFieldName[0]}.${getFieldName[1]}.staff_id`,
                resolveAppointmentServiceStaffId(serviceData, form.values.staff_id),
              );
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.parent_id`, form?.values?.id ? form?.values?.id : null);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, duration);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, padding_time);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, durationWithPadding);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, addonCost);
              // AddonGetAvailableTime({
              //   ...form.values.addonservices[getFieldNameIndex],
              //   parent_id: form.values && form.values.id ? form.values.id : "",
              //   service_id: option && option.value,
              //   dateof: form.values.dateof,
              //   duration: duration,
              //   padding_time: padding_time,
              //   durationWithPadding: durationWithPadding,
              //   listview: "Appointment"
              // }, dispatch);

              const addonservices = form.values.addonservices && form.values.addonservices.length > 0 ? form.values.addonservices.slice(0, getFieldNameIndex) : "";

              let parentAppointmentEndTime = "";
              // let isNotInResourceIds = [];
              // if (form.values.resource_item_id) {
              //   isNotInResourceIds.push(form.values.resource_item_id);
              // }

              if (addonservices && addonservices.length > 0) {
                const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                  // Check if sduration.durationWithPadding is a valid duration
                  const duration = moment.duration(sduration.durationWithPadding);
                  if (duration.isValid()) {
                    const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                    // if (sduration.resource_item_id) {
                    //   isNotInResourceIds.push(sduration.resource_item_id);
                    // }
                    return sum.add(sumDurationWithPadding);
                  }
                  return sum;
                }, moment.duration(0));
                // console.log('isNotInResourceIds',isNotInResourceIds);

                const parentAppointmentDuration = form.values.durationWithPadding;
                const duration1 = moment.duration(parentAppointmentDuration);
                const duration2 = totalAddOnDurationWithPadding;

                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                // isNotInResourceIds.push(form.values.resource_item_id);
              } else {
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                const durationMoment = moment.duration(form.values.durationWithPadding);

                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
              }
              parentAppointmentEndTime = containedAppointmentChildStart(form.values, getFieldName[0], getFieldName[1], parentAppointmentEndTime);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.parentAppointmentEndTime`, parentAppointmentEndTime);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.start_datetime`, parentAppointmentEndTime, false);

              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addonservices/service_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addonservices/service_id" : "")
              }
              const obj = {
                ...form.values.addonservices[getFieldNameIndex],
                remove_addon: form?.values?.remove_addon || [],
                remove_addanother: form?.values?.remove_addanother || [],
                service_id: option && option.value,
                parent_id: form.values && form.values.id ? form.values.id : "",
                staff_id: resolveAppointmentServiceStaffId(serviceData, form.values.staff_id),
                dateof: form.values.dateof,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                start_datetime: parentAppointmentEndTime,
                parentAppointmentEndTime: parentAppointmentEndTime,
                listview: "Appointment",
                formtype: "appointmentform",
                formName
              }
              const dateof = form.values.dateof && form.values.dateof ? moment(form.values.dateof, "dddd, DD MMMM YYYY").format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss") : "";
              const childId = Number(getFieldNameIndex) + 1;
              const addOnData = isAddOn.find((event) => String(event.id) === String(childId));
              let addonobj = {
                ...(addOnData || {}),
                id: childId,
                serviceprice: action.payload,
                duration,
                padding_time,
                durationWithPadding,
              };
              // A resource-backed add-on must offer its resource items before
              // submit; without this lookup the calendar saved an add-on line
              // with an empty resource and the store rejected the appointment.
              const addOnAvailabilityContext = { ...obj, dateof: dateof };
              const addOnStaffOptionsAction = dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: serviceData.id, pagetype: "Booking", availebleTimeObj: addOnAvailabilityContext }));
              const addOnResourceOptionsAction = dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: serviceData.id, pagetype: "Booking", availebleTimeObj: addOnAvailabilityContext }));
              Promise.all([addOnStaffOptionsAction, addOnResourceOptionsAction]).then(([action1, action2]) => {
                const resourceState = childResourceOptionState(
                  action2.meta.requestStatus === "fulfilled" ? action2.payload : [], serviceData,
                );
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "", false);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_allocations`, [], false);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_requirements`, resourceState.resource_requirements, false);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_required`, resourceState.resource_required);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_unavailable`, resourceState.resource_unavailable);
                dispatch(AddOnData(buildAppointmentChildOptionState({
                  existing: addonobj,
                  id: childId,
                  service: { ...serviceData, staff_id: form.values.staff_id },
                  parentStaffId: form.values.staff_id,
                  parentStaffOptions: appointmentStaffOptions,
                  staffOptions: action1.meta.requestStatus === "fulfilled" ? action1.payload : undefined,
                  resourceOptions: action2.meta.requestStatus === "fulfilled" ? resourceState.resourceOptions : undefined,
                })));
              });
            }
          }
        });
      } else {
        if (controlId) {
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.staff_id`, "");
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, "");
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, "");
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, "");
          form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, "");
          form.setFieldTouched(`${getFieldName[0]}.${getFieldName[1]}.cost`, false);
        }
        dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, pagetype: "Booking" }))
        dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, pagetype: "Booking" }));
        // AddonGetAvailableTime({
        //   ...form.values.addonservices[getFieldNameIndex],
        //   parent_id: form.values && form.values.id ? form.values.id : "",
        //   service_id: option && option.value,
        //   dateof: form.values.dateof,
        //   duration: "",
        //   padding_time: "",
        //   durationWithPadding: "",
        // }, dispatch);
      }
    }
    if (getFieldName.length == 3 && getFieldName.includes("addonservices") && getFieldName.includes("staff_id") && getControlId.includes("appointmentForm") && getControlId.includes("addonservices") && getControlId.includes("staff_id")) {
      if (option && option.value) {
        dispatch(
          AddOnServicePriceApi({
            parent_service_id: form.values.service_id,
            parent_staff_id: form.values.staff_id,
            service_id: form.values.addonservices[getFieldNameIndex].service_id,
            staff_id: option && option.value,
            index_id: getFieldNameIndex,
          }),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            const prevObj = form.values.addonservices[getFieldNameIndex]?.prevObj;
            // const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            // const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "";
            // const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")
            // console.log('form.values',form.values);
            const duration = form.values.addonservices[getFieldNameIndex].duration && /^\d{1,2}:\d{2}$/.test(form.values.addonservices[getFieldNameIndex].duration) ? form.values.addonservices[getFieldNameIndex].duration : "";
            const padding_time = form.values.addonservices[getFieldNameIndex].padding_time && /^\d{1,2}:\d{2}$/.test(form.values.addonservices[getFieldNameIndex].padding_time) > 0 ? form.values.addonservices[getFieldNameIndex].padding_time : "";

            let durationWithPadding = duration;
            if (padding_time) {
              const duration1 = moment.duration(duration);
              const duration2 = moment.duration(padding_time);

              const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;

              const sumDuration = moment({ hours, minutes });
              const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

              // const durationMoment = moment.duration(SumOfDuration);
              durationWithPadding = SumOfDuration
            }
            if (controlId === `appointmentForm-addonservices-${getFieldNameIndex}-staff_id`) {
              if (prevObj && prevObj.staff_id == option.value) {
                const restored = normalizeAppointmentResourceSelection({
                  ...form.values.addonservices[getFieldNameIndex],
                  ...serviceData,
                  resource_required: childResourceOptionState([], serviceData).resource_required,
                  resource_item_id: prevObj.resource_item_id,
                });
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, restored.resource_item_id);
                form.values.addonservices[getFieldNameIndex].resource_item_id = restored.resource_item_id;
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_allocations`, restored.resource_allocations || [], false);
                form.values.addonservices[getFieldNameIndex].resource_allocations = restored.resource_allocations || [];
              } else {
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
                form.values.addonservices[getFieldNameIndex].resource_item_id = "";
              }
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, duration);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, padding_time);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, durationWithPadding);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.parent_id`, form.values?.id);
              // const addonservices = [...form.values.addonservices]; // Create a copy of the array
              // Create a new array based on the index key
              const addonservices = form.values.addonservices && form.values.addonservices.length > 0 ? form.values.addonservices.slice(0, getFieldNameIndex) : "";

              let parentAppointmentEndTime = "";
              let isNotInResourceIds = [];
              if (form.values.resource_item_id) {
                isNotInResourceIds.push(form.values.resource_item_id);
              }

              if (addonservices && addonservices.length > 0) {
                const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                  // Check if sduration.durationWithPadding is a valid duration
                  const duration = moment.duration(sduration.durationWithPadding);
                  if (duration.isValid()) {
                    const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                    if (sduration.resource_item_id) {
                      isNotInResourceIds.push(sduration.resource_item_id);
                    }
                    return sum.add(sumDurationWithPadding);
                  }
                  return sum;
                }, moment.duration(0));
                // console.log('isNotInResourceIds',isNotInResourceIds);

                const parentAppointmentDuration = form.values.durationWithPadding;
                const duration1 = moment.duration(parentAppointmentDuration);
                const duration2 = totalAddOnDurationWithPadding;

                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                // isNotInResourceIds.push(form.values.resource_item_id);
              } else {
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                const durationMoment = moment.duration(form.values.durationWithPadding);

                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                // console.log('durationMoment',form.values.durationWithPadding, durationMoment.asMinutes(),parentAppointmentEndTime);
              }
              parentAppointmentEndTime = containedAppointmentChildStart(form.values, getFieldName[0], getFieldName[1], parentAppointmentEndTime);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.parentAppointmentEndTime`, parentAppointmentEndTime);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.start_datetime`, parentAppointmentEndTime);

              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addonservices/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addonservices/staff_id" : "")
              }
              const obj = {
                ...form.values.addonservices[getFieldNameIndex],
                remove_addon: form?.values?.remove_addon || [],
                remove_addanother: form?.values?.remove_addanother || [],
                parent_id: form.values && form.values.id ? form.values.id : "",
                staff_id: option && option.value,
                dateof: form.values.dateof,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                parentAppointmentEndTime: parentAppointmentEndTime,
                start_datetime: parentAppointmentEndTime,
                listview: "Appointment",
                formtype: "appointmentform",
                formName,
                prevObj
              }
              const dateof = form.values.dateof && form.values.dateof ? moment(form.values.dateof, "dddd, DD MMMM YYYY").format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss") : "";

              const childId = Number(getFieldNameIndex) + 1;
              const addOnData = isAddOn.find((event) => String(event.id) === String(childId));
              let addonobj = {
                ...(addOnData || {}),
                id: childId,
                serviceprice: action.payload,
                duration,
                padding_time,
                durationWithPadding,
              };
              dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: obj.service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj, dateof: dateof } })).then((actionResource) => {
                const resourceState = childResourceOptionState(
                  actionResource.meta.requestStatus === "fulfilled" ? actionResource.payload : [], serviceData,
                );
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_allocations`, [], false);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_requirements`, resourceState.resource_requirements, false);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_required`, resourceState.resource_required);
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_unavailable`, resourceState.resource_unavailable);
                dispatch(AddOnData(buildAppointmentChildOptionState({
                  existing: addonobj,
                  id: childId,
                  service: form.values.addonservices[getFieldNameIndex],
                  parentStaffId: form.values.staff_id,
                  parentStaffOptions: appointmentStaffOptions,
                  resourceOptions: actionResource.meta.requestStatus === "fulfilled" ? actionResource.payload : undefined,
                })));
              });
              AddonGetAvailableTime({...obj, availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`}, dispatch);
            }
            form.setFieldValue(
              `${getFieldName[0]}.${getFieldName[1]}.cost`,
              resolveAppointmentAddonCost(serviceData),
            );

            // const addOnData = isAddOn.find((event) => event.id === indexID);
            // let addonobj = { ...addOnData, cost: service.duration };
            // dispatch(AddOnData(addonobj));
          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addonservices/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addonservices/staff_id" : "")
        }
        AddonGetAvailableTime({
          availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
          ...form.values.addonservices[getFieldNameIndex],
          remove_addon: form?.values?.remove_addon || [],
          remove_addanother: form?.values?.remove_addanother || [],
          parent_id: form.values && form.values.id ? form.values.id : "",
          staff_id: option && option.value,
          dateof: form.values.dateof,
          duration: "",
          padding_time: "",
          durationWithPadding: "",
          formName
        }, dispatch);
        form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, "");
        form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, "");
        form.setFieldTouched(`${getFieldName[0]}.${getFieldName[1]}.cost`, false);
      }
    }
    if (getFieldName.length == 3 && getFieldName.includes("addonservices") && getFieldName.includes("resource_item_id") && getControlId.includes("appointmentForm") && getControlId.includes("addonservices") && getControlId.includes("resource_item_id")) {
      if (option && option.value) {
        dispatch(
          AddOnServicePriceApi({
            parent_service_id: form.values.service_id,
            parent_staff_id: form.values.staff_id,
            service_id: form.values.addonservices[getFieldNameIndex].service_id,
            staff_id: form.values.addonservices[getFieldNameIndex].staff_id,
            index_id: getFieldNameIndex,
          }),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            // const serviceData = action.payload;
            // const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            // const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "";
            // const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")

            const serviceData = action.payload;
            const serviceDataNew = form.values.addonservices[getFieldNameIndex];
            const serviceFields = buildAppointmentServiceFields(
              {
                duration: serviceDataNew && serviceDataNew.duration,
                padding_time: serviceData.padding_time,
              },
              form.values.staff_id,
            );
            const duration = serviceFields.duration;
            const padding_time = serviceFields.padding_time;
            const durationWithPadding = serviceFields.durationWithPadding;

            if (controlId === `appointmentForm-addonservices-${getFieldNameIndex}-resource_item_id`) {
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, duration);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, padding_time);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, durationWithPadding);

              // const addonservices = [...form.values.addonservices]; // Create a copy of the array
              // Create a new array based on the index key
              const addonservices = form.values.addonservices && form.values.addonservices.length > 0 ? form.values.addonservices.slice(0, getFieldNameIndex) : "";

              let parentAppointmentEndTime = "";
              if (addonservices && addonservices.length > 0) {
                const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                  // Check if sduration.durationWithPadding is a valid duration
                  const duration = moment.duration(sduration.durationWithPadding);
                  if (duration.isValid()) {
                    const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                    return sum.add(sumDurationWithPadding);
                  }
                  return sum;
                }, moment.duration(0));


                const parentAppointmentDuration = form.values.durationWithPadding;
                const duration1 = moment.duration(parentAppointmentDuration);
                const duration2 = totalAddOnDurationWithPadding;

                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

              } else {
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                const durationMoment = moment.duration(form.values.durationWithPadding);
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
              }
              parentAppointmentEndTime = containedAppointmentChildStart(form.values, getFieldName[0], getFieldName[1], parentAppointmentEndTime);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.parentAppointmentEndTime`, parentAppointmentEndTime);
              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addonservices/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addonservices/resource_item_id" : "")
              }
              AddonGetAvailableTime({
                availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
                ...form.values.addonservices[getFieldNameIndex],
                remove_addon: form?.values?.remove_addon || [],
                remove_addanother: form?.values?.remove_addanother || [],
                parent_id: form.values && form.values.id ? form.values.id : "",
                resource_item_id: option && option.value,
                dateof: form.values.dateof,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                parentAppointmentEndTime: parentAppointmentEndTime,
                listview: "Appointment",
                formName
              }, dispatch);
            }
            if (serviceData && serviceData.serviceprice) {
              let serviceprice = serviceData.serviceprice;
              let generalPrice = serviceprice;
              // let gprice = generalPrice && generalPrice.length === 1 ? generalPrice[0].price : "0.00";
              let add_on_price = generalPrice && generalPrice.length === 1 ? generalPrice[0].add_on_price : "0.00";
              // let totalprice = parseFloat(gprice) + parseFloat(add_on_price); //client need only gprice 16-12-2022
              let totalprice = parseFloat(add_on_price);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, String(totalprice));
            }

            // const addOnData = isAddOn.find((event) => event.id === indexID);
            // let addonobj = { ...addOnData, cost: service.duration };
            // dispatch(AddOnData(addonobj));
          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addonservices/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addonservices/resource_item_id" : "")
        }
        AddonGetAvailableTime({
          availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
          ...form.values.addonservices[getFieldNameIndex],
          parent_id: form.values && form.values.id ? form.values.id : "",
          resource_item_id: option && option.value,
          dateof: form.values.dateof,
          formName
          // parentAppointmentEndTime: parentAppointmentEndTime,
          // duration: "",
          // padding_time: "",
          // durationWithPadding: "",
        }, dispatch);
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, "");
        // form.setFieldTouched(`${getFieldName[0]}.${getFieldName[1]}.cost`, false);
      }
    }
    // Add another services. Load every dependent value before committing the
    // child so Add and Edit never render a half-populated selection.
    if (getFieldName.length == 3 && getFieldName.includes("addanotherservices") && getFieldName.includes("service_id") && getControlId.includes("appointmentForm") && getControlId.includes("addanotherservices") && getControlId.includes("service_id")) {
      const requestId = ++additionalSelectionRequest.current;
      if (!option?.value) {
        const nextChildren = [...(form.values.addanotherservices || [])];
        nextChildren[getFieldNameIndex] = {
          ...(nextChildren[getFieldNameIndex] || {}),
          service_id: "",
          service_name: "",
          staff_id: "",
          resource_item_id: "",
          resource_required: false,
          resource_unavailable: false,
          duration: "",
          padding_time: "",
          durationWithPadding: "",
          cost: "",
        };
        form.setValues((currentValues) => ({
          ...currentValues,
          addanotherservices: nextChildren,
        }), false);
        dispatch(AddAnotherData({ id: Number(getFieldNameIndex) + 1, staff: [], resource_items: [], availability: null, resource_required: false, resource_unavailable: false }));
        return;
      }

      const childId = Number(getFieldNameIndex) + 1;
      const existingOptionState = isAddAnother.find(
        (event) => String(event.id) === String(childId),
      ) || {};
      loadAppointmentAdditionalServiceSelection({
        childIndex: Number(getFieldNameIndex),
        existingOptionState,
        formValues: form.values,
        parentStaffOptions: appointmentStaffOptions,
        serviceId: option.value,
        loaders: {
          loadPrice: (payload) => dispatch(AddAnotherServicePriceApi(payload)),
          loadStaff: (payload) => dispatch(AddAnotherStaffOptionsApi(payload)),
          loadResources: (payload) => dispatch(AddAnotherResourceOptionsApi(payload)),
        },
      }).then((result) => {
        if (requestId !== additionalSelectionRequest.current) return;
        if (result.status !== "ready") {
          customToast.error(result.error);
          return;
        }
        if (result.notice) customToast.error(result.notice);

        const deposit = Number(result.serviceData?.deposit_booked_price || 0);
        const shouldAddDeposit = result.serviceData?.deposit_booked_online == 1 && deposit > 0;
        form.setValues((currentValues) => {
          const nextChildren = [...(currentValues.addanotherservices || [])];
          nextChildren[getFieldNameIndex] = result.child;
          return {
            ...currentValues,
            addanotherservices: nextChildren,
            service_deposit: [
              ...(currentValues.service_deposit || []),
              {
                service_id: result.child.service_id,
                deposit_price: result.serviceData?.deposit_booked_price,
                service_type: "add_another",
                total_cost: result.child.cost || "0",
              },
            ],
            totaldeposit: shouldAddDeposit
              ? (Number(currentValues.totaldeposit || 0) + deposit).toFixed(2)
              : currentValues.totaldeposit,
          };
        }, false);
        if (deposit > 0) dispatch(OpenDepositPayTab(true));
        dispatch(AddAnotherData(result.optionState));
      }).catch(() => {
        if (requestId !== additionalSelectionRequest.current) return;
        customToast.error("Unable to load the selected additional service. Please try again.");
      });
      return;
    }

    if (getFieldName.length == 3 && getFieldName.includes("addanotherservices") && getFieldName.includes("staff_id") && getControlId.includes("appointmentForm") && getControlId.includes("addanotherservices") && getControlId.includes("staff_id")) {
      if (option && option.value) {
        dispatch(
          AddAnotherServicePriceApi({
            parent_service_id: form.values.service_id,
            parent_staff_id: form.values.staff_id,
            service_id: form.values.addanotherservices[getFieldNameIndex].service_id,
            staff_id: option && option.value,
            index_id: getFieldNameIndex,
          }),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            const prevObj = form.values.addanotherservices[getFieldNameIndex]?.prevObj;

            // const duration = serviceData.duration && serviceData.duration > 0 ? MinutesToHours(serviceData.duration) : "";
            // const padding_time = serviceData.padding_time && serviceData.padding_time > 0 ? MinutesToHours(serviceData.padding_time) : "";
            // const durationWithPadding = serviceData && serviceData.padding_time ? MinutesToHours(parseInt(serviceData.padding_time) + parseInt(serviceData.duration)) : (serviceData && serviceData.duration ? MinutesToHours(serviceData.duration) : "")
            const duration = form.values.addanotherservices[getFieldNameIndex].duration && /^\d{1,2}:\d{2}$/.test(form.values.addanotherservices[getFieldNameIndex].duration) ? form.values.addanotherservices[getFieldNameIndex].duration : "";
            const padding_time = form.values.addanotherservices[getFieldNameIndex].padding_time && /^\d{1,2}:\d{2}$/.test(form.values.addanotherservices[getFieldNameIndex].padding_time) > 0 ? form.values.addanotherservices[getFieldNameIndex].padding_time : "";
            let durationWithPadding = duration;
            if (padding_time) {
              const duration1 = moment.duration(duration);
              const duration2 = moment.duration(padding_time);

              const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;

              const sumDuration = moment({ hours, minutes });
              const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

              // const durationMoment = moment.duration(SumOfDuration);
              durationWithPadding = SumOfDuration
            }
            // const duration = service && service.duration ? MinutesToHours(service.duration) : "";
            if (controlId === `appointmentForm-addanotherservices-${getFieldNameIndex}-staff_id`) {
              if (prevObj && prevObj.staff_id == option.value) {
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, prevObj.resource_item_id);
                form.values.addanotherservices[getFieldNameIndex].resource_item_id = prevObj.resource_item_id;
              } else {
                form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
                form.values.addanotherservices[getFieldNameIndex].resource_item_id = "";
              }

              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, duration);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, padding_time);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, durationWithPadding);
              // console.log('form', form.values, duration);

              const addonservices = [...form.values.addonservices];
              const addanotherservices = [...form.values.addanotherservices];

              let parentAppointmentEndTime = "";
              let isNotInResourceIds = [];
              if (form.values.resource_item_id) {
                isNotInResourceIds.push(form.values.resource_item_id);
              }
              const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                // Check if sduration.durationWithPadding is a valid duration
                const duration = moment.duration(sduration.durationWithPadding);

                if (duration.isValid()) {
                  const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                  if (sduration.resource_item_id) {
                    isNotInResourceIds.push(sduration.resource_item_id);
                  }
                  return sum.add(sumDurationWithPadding);
                }
                return sum;
              }, moment.duration(0));
              // console.log('form',  addanotherservices);
              // if (addanotherservices && addanotherservices.length > 1) {
              //   addanotherservices.pop();

              if (addanotherservices && addanotherservices.length > 1) {
                const addanotherservicesFilter = addanotherservices.slice(0, getFieldNameIndex);
                //console.log('addanotherservicesFilter', getFieldNameIndex, addanotherservicesFilter);
                const totalAddAnotherDurationWithPadding = addanotherservicesFilter.length > 0 && addanotherservicesFilter.reduce((sum, sduration) => {
                  // Check if sduration.durationWithPadding is a valid duration
                  const duration = moment.duration(sduration.durationWithPadding);
                  if (duration.isValid()) {
                    const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                    if (sduration.resource_item_id) {
                      isNotInResourceIds.push(sduration.resource_item_id);
                    }
                    return sum.add(sumDurationWithPadding);
                  }
                  return sum;
                }, moment.duration(0));

                const parentAppointmentDuration = form.values.durationWithPadding;
                const duration1 = moment.duration(parentAppointmentDuration);
                const duration2 = totalAddOnDurationWithPadding;
                const duration3 = totalAddAnotherDurationWithPadding;

                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
                const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2 + minutes3;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);

                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

              } else {
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                const duration1 = moment.duration(form.values.durationWithPadding);
                const duration2 = totalAddOnDurationWithPadding;
                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
              }
              parentAppointmentEndTime = containedAppointmentChildStart(form.values, getFieldName[0], getFieldName[1], parentAppointmentEndTime);
              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addanotherservices/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addanotherservices/staff_id" : "")
              }

              const obj = {
                ...form.values.addanotherservices[getFieldNameIndex],
                remove_addon: form?.values?.remove_addon || [],
                remove_addanother: form?.values?.remove_addanother || [],
                parent_id: form.values && form.values.id ? form.values.id : "",
                staff_id: option && option.value,
                dateof: form.values.dateof,
                parentAppointmentEndTime: parentAppointmentEndTime,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                listview: "Appointment",
                formName,
                prevObj
              }

              const dateof = form.values.dateof && form.values.dateof ? moment(form.values.dateof, "dddd, DD MMMM YYYY").format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss") : "";

              const childId = Number(getFieldNameIndex) + 1;
              const addAnotherData = isAddAnother.find((event) => String(event.id) === String(childId));

              let addanotherobj = {
                ...(addAnotherData || {}),
                id: childId,
                serviceprice: action.payload,
                duration,
                padding_time,
                durationWithPadding,
              };
              dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: obj.service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj, dateof: dateof } })).then((actionResource) => {
                dispatch(AddAnotherData(buildAppointmentChildOptionState({
                  existing: addanotherobj,
                  id: childId,
                  service: form.values.addanotherservices[getFieldNameIndex],
                  parentStaffId: form.values.staff_id,
                  parentStaffOptions: appointmentStaffOptions,
                  resourceOptions: actionResource.meta.requestStatus === "fulfilled" ? actionResource.payload : undefined,
                })));
              });
              AddAnotherGetAvailableTime({...obj, availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`}, dispatch);
            }

            if (serviceData && serviceData.serviceprice) {
              let serviceprice = serviceData.serviceprice;
              let generalPrice = serviceprice;
              let gprice = generalPrice && generalPrice.length === 1 ? generalPrice[0].price : "0.00";
              // let add_on_price = generalPrice && generalPrice.length === 1 ? generalPrice[0].add_another_price : "0.00";
              // let totalprice = parseFloat(gprice) + parseFloat(add_on_price); //client need only gprice 16-12-2022
              let totalprice = parseFloat(gprice);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, String(totalprice));
            }
            // const addAnotherData = isAddAnother.find((event) => event.id === indexID);
            // let addanotherobj = { ...addAnotherData, cost: service.duration };
            // dispatch(AddAnotherData(addanotherobj));
          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addanotherservices/staff_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addanotherservices/staff_id" : "")
        }
        AddAnotherGetAvailableTime({
          availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
          ...form.values.addanotherservices[getFieldNameIndex],
          remove_addon: form?.values?.remove_addon || [],
          remove_addanother: form?.values?.remove_addanother || [],
          parent_id: form.values && form.values.id ? form.values.id : "",
          staff_id: option && option.value,
          dateof: form.values.dateof,
          duration: "",
          padding_time: "",
          durationWithPadding: "",
          formName
        }, dispatch);
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, "");
        form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, "");
        form.setFieldTouched(`${getFieldName[0]}.${getFieldName[1]}.cost`, false);
      }
    }
    if (getFieldName.length == 3 && getFieldName.includes("addanotherservices") && getFieldName.includes("resource_item_id") && getControlId.includes("appointmentForm") && getControlId.includes("addanotherservices") && getControlId.includes("resource_item_id")) {
      if (option && option.value) {
        dispatch(
          AddAnotherServicePriceApi({
            parent_service_id: form.values.service_id,
            parent_staff_id: form.values.staff_id,
            service_id: form.values.addanotherservices[getFieldNameIndex].service_id,
            staff_id: form.values.addanotherservices[getFieldNameIndex].staff_id,
            index_id: getFieldNameIndex,
          }),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const serviceData = action.payload;
            const serviceDataNew = form.values.addanotherservices[getFieldNameIndex];
            const serviceFields = buildAppointmentServiceFields(
              {
                duration: serviceDataNew && serviceDataNew.duration,
                padding_time: serviceData.padding_time,
              },
              form.values.staff_id,
            );
            const duration = serviceFields.duration;
            const padding_time = serviceFields.padding_time;
            const durationWithPadding = serviceFields.durationWithPadding;
            // console.log('serviceData',duration,padding_time,durationWithPadding);
            // const duration = service && service.duration ? MinutesToHours(service.duration) : "";
            if (controlId === `appointmentForm-addanotherservices-${getFieldNameIndex}-resource_item_id`) {
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.duration`, duration);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, padding_time);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, durationWithPadding);
              // console.log('form', form.values, duration);

              const addonservices = [...form.values.addonservices];
              const addanotherservices = [...form.values.addanotherservices];

              let parentAppointmentEndTime = "";

              const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                // Check if sduration.durationWithPadding is a valid duration
                const duration = moment.duration(sduration.durationWithPadding);

                if (duration.isValid()) {
                  const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                  return sum.add(sumDurationWithPadding);
                }
                return sum;
              }, moment.duration(0));
              // console.log('form',  addanotherservices);
              // if (addanotherservices && addanotherservices.length > 1) {
              //   addanotherservices.pop();

              if (addanotherservices && addanotherservices.length > 1) {
                const addanotherservicesFilter = addanotherservices.slice(0, getFieldNameIndex);
                //console.log('addanotherservicesFilter', getFieldNameIndex, addanotherservicesFilter);
                const totalAddAnotherDurationWithPadding = addanotherservicesFilter.length > 0 && addanotherservicesFilter.reduce((sum, sduration) => {
                  // Check if sduration.durationWithPadding is a valid duration
                  const duration = moment.duration(sduration.durationWithPadding);
                  if (duration.isValid()) {
                    const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                    return sum.add(sumDurationWithPadding);
                  }
                  return sum;
                }, moment.duration(0));

                const parentAppointmentDuration = form.values.durationWithPadding;
                const duration1 = moment.duration(parentAppointmentDuration);
                const duration2 = totalAddOnDurationWithPadding;
                const duration3 = totalAddAnotherDurationWithPadding;

                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
                const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2 + minutes3;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);

                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

              } else {
                const appointmentStartDateTime = moment(`${form.values.dateof} ${form.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                const duration1 = moment.duration(form.values.durationWithPadding);
                const duration2 = totalAddOnDurationWithPadding;
                // Check if each duration is valid before using it
                const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                const totalMinutes = minutes1 + minutes2;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                const sumDuration = moment({ hours, minutes });
                const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                const durationMoment = moment.duration(SumOfDuration);
                parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
              }

              parentAppointmentEndTime = containedAppointmentChildStart(form.values, getFieldName[0], getFieldName[1], parentAppointmentEndTime);
              let formName = "";
              if (form.values && form.values.form_types) {
                formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addanotherservices/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addanotherservices/resource_item_id" : "")
              }
              AddAnotherGetAvailableTime({
                availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
                ...form.values.addanotherservices[getFieldNameIndex],
                remove_addon: form?.values?.remove_addon || [],
                remove_addanother: form?.values?.remove_addanother || [],
                parent_id: form.values && form.values.id ? form.values.id : "",
                resource_item_id: option && option.value,
                dateof: form.values.dateof,
                parentAppointmentEndTime: parentAppointmentEndTime,
                duration: duration,
                padding_time: padding_time,
                durationWithPadding: durationWithPadding,
                listview: "Appointment",
                formName
              }, dispatch);
            }
            if (serviceData && serviceData.serviceprice) {
              let serviceprice = serviceData.serviceprice;
              let generalPrice = serviceprice;
              let gprice = generalPrice && generalPrice.length === 1 ? generalPrice[0].price : "0.00";
              // let add_on_price = generalPrice && generalPrice.length === 1 ? generalPrice[0].add_another_price : "0.00";
              // let totalprice = parseFloat(gprice) + parseFloat(add_on_price); //client need only gprice 16-12-2022
              let totalprice = parseFloat(gprice);
              form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, String(totalprice));
            }
            // const addAnotherData = isAddAnother.find((event) => event.id === indexID);
            // let addanotherobj = { ...addAnotherData, cost: service.duration };
            // dispatch(AddAnotherData(addanotherobj));
          }
        });
      } else {
        let formName = "";
        if (form.values && form.values.form_types) {
          formName = form.values.form_types === "add_appointment" ? "appointmentForm/add/addanotherservices/resource_item_id" : (form.values.form_types === "edit_appointment" ? "appointmentForm/edit/addanotherservices/resource_item_id" : "")
        }
        AddAnotherGetAvailableTime({
          availability_owner: `${form.values.form_types}/${getFieldName[0]}/${getFieldNameIndex}`,
          ...form.values.addanotherservices[getFieldNameIndex],
          parent_id: form.values && form.values.id ? form.values.id : "",
          resource_item_id: option && option.value,
          dateof: form.values.dateof,
          formName
          // duration: "",
          // padding_time: "",
          // durationWithPadding: "",
        }, dispatch);
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.resource_item_id`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.padding_time`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.durationWithPadding`, "");
        // form.setFieldValue(`${getFieldName[0]}.${getFieldName[1]}.cost`, "");
        // form.setFieldTouched(`${getFieldName[0]}.${getFieldName[1]}.cost`, false);
      }
    }

    if (field.name === "form_id" && controlId === "consulationForm-form_id") {
      let form_url = option ? config.form_url + "" + option.uid : "";
      form.setFieldValue(`form_url`, form_url);
    }
    if (field.name === "form_id" && controlId === "appointmentcampaignForm-form_id") {
      let form_url = option ? config.form_url + "" + option.uid : "";
      form.setFieldValue(`form_url`, form_url);
      const updatedDescription = form.values && form.values.description.replace(/http[s]?:\/\/\S+/g, '');
      form.setFieldValue(`description`, updatedDescription + ' ' + form_url);
    }
    if (field.name === "form_id" && controlId === "notifyForm-form_id") {
      let form_url = option ? config.form_url + "" + option.uid : "";
      form.setFieldValue(`form_url`, form_url);
      const updatedDescription = form.values && form.values.sms_template.replace(/http[s]?:\/\/\S+/g, '');
      form.setFieldValue(`sms_template`, updatedDescription + ' ' + form_url);
    }
    if (option) {
      form.setFieldValue(field.name, isMulti ? option.map((item) => item.value) : option.value);
    } else {
      form.setFieldValue(field.name, isMulti ? "" : "");
    }
  };

  useEffect(() => {
    if (page !== "newsale" || defaultStaffId === null || defaultStaffId === undefined || defaultStaffId === "" || field.value) return;
    const option = Array.isArray(options)
      ? options.find((candidate) => String(candidate.value) === String(defaultStaffId))
      : null;
    if (!option) return;
    const selectionKey = `${field.name}:${service_id}:${option.value}`;
    if (appliedDefaultStaff.current === selectionKey) return;
    appliedDefaultStaff.current = selectionKey;
    onChange(option);
  }, [page, defaultStaffId, field.name, field.value, service_id, options, onChange]);

  useEffect(() => {
    const calendarStaffField = field.name === "staff_id"
      && ["appointmentForm-staff_id", "appointmentautofillForm-staff_id"].includes(controlId);
    const selectedServiceId = form.values?.service_id || service_id;
    if (!calendarStaffField || field.value || !selectedServiceId
      || appointmentStaffOptionsStatus !== "succeeded"
      || String(appointmentStaffOptionServiceId) !== String(selectedServiceId)
      || !Array.isArray(options) || options.length !== 1) return;
    const option = options[0];
    const selectionKey = `${controlId}:${selectedServiceId}:${option.value}`;
    if (appliedDefaultStaff.current === selectionKey) return;
    appliedDefaultStaff.current = selectionKey;
    onChange(option);
  }, [field.name, field.value, controlId, form.values?.service_id, service_id,
    appointmentStaffOptionServiceId, appointmentStaffOptionsStatus, options, onChange]);

  const getValue = () => {
    if (options) {
      if (field.value == "") {
        return isMulti ? [] : "";
      }
      return isMulti
        ? options.filter((option) =>
          Array.isArray(field.value) && field.value.some((value) => String(option.value) === String(value)),
        )
        : options.find((option) => String(option.value) === String(field.value));
    } else {
      return isMulti ? [] : "";
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "",
      borderWidth: state.isFocused ? "0" : "0",
    }),
    control: (provided, state) => ({
      ...provided,
      borderWidth: state.isFocused ? "0px" : "1px",
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 3 }),
    menu: (provided) => ({ ...provided, zIndex: 3 }),
  };
  return (
    <>
      <Select
        ref={selectRef}
        className={className}
        id={controlId}
        name={field.name}
        value={getValue()}
        onChange={onChange}
        placeholder={placeholder}
        options={options ? options : []}
        isMulti={isMulti}
        isClearable
        styles={customStyles}
        noOptionsMessage={noOptionsMessage}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            border: "1px",
            primary25: "#F4EEEB",
            primary: "#8C1C4D",
          },
        })}
      />
    </>
  );
};

CustomSelect.propTypes = {
  staff_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  page_name: PropTypes.string,
  singlestaffaccess: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  placeholder: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  options: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  isMulti: PropTypes.bool,
  controlId: PropTypes.string,
  service_id: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  defaultStaffId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resource_item_id: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  page: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  isAddOn: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  isAddAnother: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  indexID: PropTypes.number,
};

export default CustomSelect;
